/* Travel module — sample data + rules ported from the prototype. */

export const TRAVEL_REQUESTS = [
  { id: "TR-2023-045", destination: "Kuching", purpose: "Client Site Visit", departure: "Jul 3, 2026", ret: "Jul 4, 2026", amount: "850.00", status: "Approved", updated: "Jun 14, 2026, 8:23 am" },
  { id: "TR-2023-041", destination: "Singapore", purpose: "ITB Asia 2026", departure: "Jun 15, 2026", ret: "Jul 16, 2026", amount: "410.00", status: "Approved", updated: "Jun 12, 2026, 10:22 am" },
  { id: "TR-2023-043", destination: "Kuala Lumpur", purpose: "MICE Summit 2025", departure: "Jun 20, 2025", ret: "Jun 22, 2025", amount: "3,200.00", status: "Pending", updated: "Jun 14, 2026, 9:40 am" },
  { id: "TR-2023-040", destination: "Johor Bahru", purpose: "Regional Sales Meeting", departure: "Jun 25, 2025", ret: "Jun 26, 2025", amount: "980.00", status: "Pending", updated: "Jun 13, 2026, 4:10 pm" },
  { id: "TR-2023-039", destination: "Singapore", purpose: "ITCM Asia 2025", departure: "Jul 15, 2026", ret: "Jul 18, 2026", amount: "4,100.00", status: "Approved", updated: "Jun 11, 2026, 9:30 am" },
  { id: "TR-2023-037", destination: "Jakarta, Indonesia", purpose: "Sales Mission", departure: "Jun 30, 2025", ret: "Jul 2, 2025", amount: "2,950.00", status: "Completed", updated: "Jun 10, 2026, 8:15 am" },
  { id: "TR-2023-038", destination: "Bangkok, Thailand", purpose: "HR Conference", departure: "Apr 28, 2026", ret: "Apr 30, 2026", amount: "2,750.00", status: "Rejected", updated: "May 29, 2026, 10:22 am" },
  { id: "TR-2023-029", destination: "Singapore", purpose: "ITCM Asia 2025", departure: "May 10, 2026", ret: "May 13, 2026", amount: "6,500.00", status: "Completed", updated: "May 1, 2026, 9:02 am" },
];

/* insurance: 'annual'  = staff covered by the company annual policy
              'per-trip' = Admin buys insurance for each trip */
export const REQUEST_INFO = {
  "TR-2023-045": { status: "Approved", insurance: "annual" },
  "TR-2023-041": { status: "Approved", insurance: "per-trip" },
  "TR-2023-043": { status: "Pending", insurance: "per-trip" },
  "TR-2023-040": { status: "Pending", insurance: "annual" },
  "TR-2023-039": { status: "Approved", insurance: "per-trip" },
  "TR-2023-037": { status: "Completed", insurance: "per-trip" },
  "TR-2023-038": { status: "Rejected", insurance: "per-trip" },
  "TR-2023-029": { status: "Completed", insurance: "annual" },
};

export const getRequestInfo = (id) => REQUEST_INFO[id] || { status: "Approved", insurance: "per-trip" };

export const STATUS_BADGE_CLASS = {
  Approved: "bes-badge-approved",
  Pending: "bes-badge-pending",
  Rejected: "bes-badge-rejected",
  Completed: "bes-badge-completed",
};

/* Approval flow: Requestor -> Head of Unit -> Head of Department ->
   Admin review (item costs) -> Admin approval & acknowledgement. */
export const buildTimeline = (status) => {
  const submitted = { state: "done", title: "Request submitted", meta: "Eldren Aniell Dunggat · 12 Jun 2026, 10:22 am" };
  const flows = {
    Pending: [
      submitted,
      { state: "current", title: "Head of Unit approval", meta: "Awaiting review by Denny Tan Yee Soon" },
      { state: "pending", title: "Head of Department approval", meta: "Starts after Head of Unit approves" },
      { state: "pending", title: "Admin review — item costs", meta: "Admin fills in the cost of each item" },
      { state: "pending", title: "Admin approval & acknowledgement", meta: "Requestor is notified once Admin approves" },
    ],
    Approved: [
      submitted,
      { state: "done", title: "Approved by Head of Unit", meta: "Denny Tan Yee Soon · 12 Jun 2026, 3:40 pm" },
      { state: "done", title: "Approved by Head of Department", meta: "Andrea Kahar · 13 Jun 2026, 9:05 am" },
      { state: "current", title: "Admin review — item costs", meta: "Admin fills in the cost of each item in the Approval module" },
      { state: "pending", title: "Admin approval & acknowledgement", meta: "Requestor is notified once Admin approves" },
    ],
    Rejected: [
      submitted,
      { state: "done", title: "Approved by Head of Unit", meta: "Denny Tan Yee Soon · 12 Jun 2026, 3:40 pm" },
      { state: "rejected", title: "Rejected by Head of Department", meta: "Andrea Kahar · 13 Jun 2026, 9:05 am — see reason above" },
      { state: "pending", title: "Admin review — item costs", meta: "Not started — request was rejected" },
    ],
    Completed: [
      submitted,
      { state: "done", title: "Approved by Head of Unit", meta: "Denny Tan Yee Soon · 12 Jun 2026, 3:40 pm" },
      { state: "done", title: "Approved by Head of Department", meta: "Andrea Kahar · 13 Jun 2026, 9:05 am" },
      { state: "done", title: "Admin review — item costs", meta: "Nurul Hazwani · 14 Jun 2026, 11:20 am" },
      { state: "done", title: "Admin approved & requestor acknowledged", meta: "Nurul Hazwani · 14 Jun 2026, 4:45 pm" },
    ],
  };
  return flows[status] || flows.Approved;
};

export const REJECTION_REASON =
  'Head of Department: "Conference budget exceeds the remaining quota for this quarter. Please defer to the next financial year."';

export const ACTIVITY_LOG = [
  { time: "14 Jun 2026, 11:20 am", by: "Nurul Hazwani", role: "Admin", action: "Costs Updated", badge: "info", detail: "Item costs entered: Flight Ticket RM 1,850.00 · Hotel (Marina Bay Sands) RM 1,140.00 · Hotel (Hotel Boss) RM 180.00" },
  { time: "13 Jun 2026, 9:05 am", by: "Andrea Kahar", role: "Head of Department", action: "Approved", badge: "approved", detail: '2nd approval granted. Note: "Budget within limits, proceed."' },
  { time: "12 Jun 2026, 3:40 pm", by: "Denny Tan Yee Soon", role: "Head of Unit", action: "Approved", badge: "approved", detail: '1st approval granted. Note: "Schedule confirmed with the team."' },
  { time: "12 Jun 2026, 10:22 am", by: "Eldren Aniell Dunggat", role: "Requestor", action: "Amended", badge: "amend", detail: 'Resubmitted after amendment. Changes: Departure Date 24/08/2026 → 25/08/2026 · Hotel nights 5 → 4. Reason: "Flight on 24/08 cancelled by airline."' },
  { time: "11 Jun 2026, 4:15 pm", by: "Denny Tan Yee Soon", role: "Head of Unit", action: "Rejected", badge: "reject", detail: 'Reason: "Departure date clashes with the unit event on 24/08. Please adjust the schedule and resubmit."' },
  { time: "11 Jun 2026, 9:00 am", by: "Eldren Aniell Dunggat", role: "Requestor", action: "Submitted", badge: "info", detail: "Request submitted for approval. Cash advance requested: RM 870.00." },
  { time: "10 Jun 2026, 5:32 pm", by: "Eldren Aniell Dunggat", role: "Requestor", action: "Created", badge: "muted", detail: "Draft created from New Travel Request." },
];
